import { styled, css } from '@mui/material/styles';
import { Box, DialogTitle, Typography } from '@mui/material';

interface PageProps {
  hasCaptcha: boolean;
}

export const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

export const Content = styled(Box)`
  display: flex;
  /* height: calc(100vh - 60px); */
  overflow: hidden;
  flex: 1;
`;

export const Page = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px;
  gap: 10px;

  width: 427px;
  height: 454px;

  ${(props: PageProps) =>
    props.hasCaptcha &&
    css`
      height: calc(454px + 65px + 1rem);
    `}
`;

export const DialogTitleStyles = styled(DialogTitle)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 32px;
  text-align: center;
  letter-spacing: 0.15px;
  color: #000000;
`;

export const Divider = styled(Box)`
  width: 367px;
  height: 1px;
  border: 1px solid #9e9e9e;
  margin-top: 10px;
`;

export const DialogTextStyles = styled(Typography)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0.15px;
  color: #616161;
`;
